import React from 'react';
import Modal from '../modal';
import { CDN_CLRSAVE_URL } from '../../constants';
import { Router } from '../../configs/routes';
import { trackAction } from '../../utils/trackActions';
import { getUserInfoSessionData } from '../../utils/sessionUtil';

interface Props {
  amount: number;
  investmentType: string;
  sipDate: string;
  firstPaymentDate: string;
}

const goToDashboard = () => {
  trackAction('click', 'schedule-payment-flow', 'go-to-dashboard');
  Router.pushRoute('/save/dashboard/portfolio');
};

const PaymentLinkScheduleModal = (props: Props) => {
  const { amount, investmentType, sipDate, firstPaymentDate } = props;
  const userInfoData = getUserInfoSessionData();
  const sipDateText =
    investmentType === 'SIP_MF'
      ? sipDate + 'th of every month'
      : new Date(firstPaymentDate).toDateString().slice(4);
  return (
    <Modal fullScreen width="800px" hideHeader>
      <div className="center pt20 pb60 height">
        <div>
          <img
            src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/1571732549_checked1.svg`}
            alt="success"
            className="mb10"
          />
        </div>
        <div className="bold mb10 text--xlg">Congratulations!</div>
        <div className="mb30">
          You’ve been registered to receive payment links over email
        </div>

        <div className="mb10 w80">
          Your email <strong>{userInfoData && userInfoData.email}</strong> has
          been registered to receive payment links 2 days before{' '}
          <strong>{sipDateText}</strong> for{' '}
          <strong>₹{amount.toLocaleString('en-IN')}</strong>
        </div>
        <div className="mb30">
          The Payment links will be valid for a few days from the day of
          receiving
        </div>

        <button
          className="btn-blue btn-small cursor--pointer"
          onClick={goToDashboard}
        >
          GO TO DASHBOARD
        </button>
      </div>
      <style>
        {`
            @media screen and (min-width: 768.1px) {
              .height{
                height: 385px;
              }
            }
            @media screen and (min-width: 640.1px) {
              .w80{
                width: 80%;
                margin: auto;
              }
            }
            `}
      </style>
    </Modal>
  );
};

export default PaymentLinkScheduleModal;



// WEBPACK FOOTER //
// ./components/mandate/PaymentLinkScheduleModal.tsx